import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRightIcon } from 'lucide-react';
export function WhyDiagnosticMatters() {
  return <section className="py-20 px-4 bg-white pt-[50px] pb-[50px]" data-id="element-220">
      <div className="max-w-4xl mx-auto text-center" data-id="element-221">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} data-id="element-222">
          <span className="uppercase tracking-widest text-sm font-bold text-brand-accent mb-4 block" data-id="element-223">
            Why other shops miss it
          </span>
          <h2 className="font-heading uppercase tracking-wide text-3xl md:text-4xl lg:text-5xl font-extrabold text-brand-dark mb-12" data-id="element-224">
            Modern vehicles contain dozens of computers and interconnected
            systems.
          </h2>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="space-y-6 text-lg md:text-xl text-gray-700 leading-relaxed" data-id="element-225">
          <p className="pl-[0px] pr-[0px]" data-id="element-226">
            Basic scan tools only read stored fault codes. Those codes point
            technicians in the right direction — but they rarely identify the
            exact component that failed.
          </p>

          <p data-id="element-227">
            If deeper testing isn't performed, repairs often follow a
            trial-and-error path:
          </p>

          {/* Flow Card */}
          <div className="bg-brand-light rounded-2xl p-6 md:p-8 border border-gray-200 my-10 flex flex-col md:flex-row items-center justify-center gap-4 md:gap-6 text-center shadow-sm" data-id="element-228">
            <div className="bg-white px-4 py-3 rounded-lg border border-gray-200 font-medium text-brand-dark w-full md:w-auto shadow-sm" data-id="element-229">
              Read code
            </div>
            <ArrowRightIcon className="w-6 h-6 text-brand-accent hidden md:block" data-id="element-230" />
            <div className="text-brand-accent md:hidden" data-id="element-231">↓</div>
            <div className="bg-white px-4 py-3 rounded-lg border border-gray-200 font-medium text-brand-dark w-full md:w-auto shadow-sm" data-id="element-232">
              Replace the most likely part
            </div>
            <ArrowRightIcon className="w-6 h-6 text-brand-accent hidden md:block" data-id="element-233" />
            <div className="text-brand-accent md:hidden" data-id="element-234">↓</div>
            <div className="bg-white px-4 py-3 rounded-lg border border-gray-200 font-medium text-brand-dark w-full md:w-auto shadow-sm" data-id="element-235">
              See if the problem returns
            </div>
          </div>

          <p data-id="element-236">
            Many repair shops only have access to basic code readers, even when
            the technicians are highly experienced.
          </p>

          <p data-id="element-237">
            When the root cause isn't confirmed, what seemed like a faster or
            cheaper repair can turn into multiple visits, unnecessary parts, and
            ongoing problems.
          </p>
        </motion.div>
      </div>
    </section>;
}